import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

export default function TaxonomyHome() {
  const navigate = useNavigate();
  const { t } = useTranslation(['taxonomy', 'common']);

  const titleSx = {
    fontWeight: 800,
    letterSpacing: "0.01em",
    color: "text.primary",
    textAlign: "center",
    mb: 1,
  };

  const subtitleSx = {
    textAlign: "center",
    whiteSpace: "pre-line",
    color: "text.secondary",
    maxWidth: 820,
    mx: "auto",
    mb: 4,
  };

  const taxonomyCards = [
    {
      title: t('common:taxonExplorer'),
      description: t('taxonomy:home.cards.taxonExplorerDescription'),
      link: '/taxonomy/taxon-explore',
      icon: <AccountTreeIcon fontSize="large" />
    },
    // Future taxonomy-related analysis can be added here.
  ];

  return (
    <Box p={4}>
      <Container maxWidth="lg">
        <Typography variant="h2" sx={titleSx}>
          {t('taxonomy:title')}
        </Typography>
        <Typography variant="body1" sx={subtitleSx}>
          {t('taxonomy:home.description1')}
        </Typography>
        <Typography variant="body1" sx={subtitleSx}>
          {t('taxonomy:home.description2')}
        </Typography>

        <Grid container spacing={4} sx={{ mt: 4 }}>
          {taxonomyCards.map((card, index) => (
            <Grid item xs={12} md={6} key={index}>
              <CardActionArea component="div" onClick={() => navigate(card.link)} sx={{ height: '100%' }}>
                <Card sx={{ display: 'flex', alignItems: 'center', p: 2, height: '100%' }}>
                  <Box sx={{ p: 2, display: { xs: 'none', sm: 'block' } }}>
                    {card.icon}
                  </Box>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>{card.title}</Typography>
                    <Typography variant="body2" color="text.secondary">{card.description}</Typography>
                  </CardContent>
                </Card>
              </CardActionArea>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
